import React, {
  useEffect,
  useState,
} from "react";

import {
  Link,
} from "react-router-dom";

/* =========================================================
   CONFIG
========================================================= */

const KIND_TOKEN =
  "0x41f52A42091A6B2146561bF05b722Ad1d0e46f8b";

const KIND_WBNB_PAIR =
  "0x628C0fe6DA9854EDf0f3E2C7657af6ecf29C740E";

const PANCAKESWAP_URL =
  `https://pancakeswap.finance/swap?outputCurrency=${KIND_TOKEN}`;

const DEXSCREENER_URL =
  `https://dexscreener.com/bsc/${KIND_WBNB_PAIR}`;

const BSCSCAN_URL =
  `https://bscscan.com/token/${KIND_TOKEN}`;

/* =========================================================
   HOME
========================================================= */

export default function Home() {
  return (
    <div className="min-h-screen overflow-hidden bg-[#050609] text-white">

      {/* =====================================================
          HERO
      ===================================================== */}

      <section className="relative overflow-hidden border-b border-white/[0.07]">

        {/* BACKGROUND GLOWS */}

        <div className="pointer-events-none absolute left-1/2 top-[-320px] h-[720px] w-[900px] -translate-x-1/2 rounded-full bg-[#ffcc66]/[0.08] blur-[160px]" />

        <div className="pointer-events-none absolute bottom-[-320px] left-[-250px] h-[600px] w-[600px] rounded-full bg-[#ffcc66]/[0.035] blur-[150px]" />

        <div className="pointer-events-none absolute bottom-[-300px] right-[-250px] h-[600px] w-[600px] rounded-full bg-[#ffcc66]/[0.035] blur-[150px]" />

        {/* GRID */}

        <div
          className="pointer-events-none absolute inset-0 opacity-[0.035]"
          style={{
            backgroundImage:
              "linear-gradient(rgba(255,255,255,0.4) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.4) 1px, transparent 1px)",
            backgroundSize:
              "50px 50px",
          }}
        />

        <div className="relative mx-auto flex min-h-[760px] max-w-[1250px] items-center justify-center px-5 py-20 sm:px-8 lg:px-10">

          <div className="w-full text-center">

            {/* BADGE */}

            <div className="inline-flex items-center gap-2 rounded-full border border-[#ffcc66]/20 bg-[#ffcc66]/[0.06] px-4 py-2">

              <span className="h-2 w-2 rounded-full bg-[#ffcc66] shadow-[0_0_14px_rgba(255,204,102,0.85)]" />

              <span className="text-[9px] font-black uppercase tracking-[0.22em] text-[#ffcc66] sm:text-[10px]">
                KIND CAT TOKEN
              </span>

            </div>

            {/* TITLE */}

            <h1 className="mx-auto mt-7 whitespace-nowrap text-[32px] font-black uppercase leading-none tracking-[-0.035em] sm:text-[40px] md:text-[50px] lg:text-[60px]">
              KIND BONUS{" "}
              <span className="text-[#ffcc66]">
                RUSH
              </span>
            </h1>

            {/* ANIMATED RUSH WORDS */}

            <AnimatedRushWords />

            {/* DESCRIPTION */}

            <p className="mx-auto mt-7 max-w-[760px] text-base font-semibold leading-8 text-[#d1d1d1] sm:text-lg">
              A new way to experience Kind Cat Token.
            </p>

            <p className="mx-auto mt-4 max-w-[820px] text-sm leading-7 text-[#8e8e8e] sm:text-[15px] sm:leading-8">
              KIND Bonus Rush is exclusively for{" "}
              <strong className="font-bold text-white">
                NEW-to-$KIND wallets
              </strong>{" "}
              — wallets that have never previously bought,
              held, received or interacted with $KIND.
            </p>

            <p className="mx-auto mt-3 max-w-[820px] text-sm leading-7 text-[#8e8e8e] sm:text-[15px] sm:leading-8">
              Buy $KIND during an active Rush, hold your
              position and unlock a potential bonus based
              on your qualifying purchase.
            </p>

            {/* BONUS DISPLAY */}

            <div className="mx-auto mt-9 max-w-[850px] rounded-[18px] border border-[#ffcc66]/20 bg-[#ffcc66]/[0.035] p-5 backdrop-blur-sm sm:p-7">

              <div className="text-[10px] font-black uppercase tracking-[0.22em] text-[#ffcc66] sm:text-[11px]">
                UP TO 300% KIND BONUS 🔥
              </div>

              <p className="mx-auto mt-3 max-w-[650px] text-xs leading-6 text-[#8e8e8e] sm:text-sm">
                The more qualifying $KIND you buy, the higher
                the bonus tier you can unlock.
              </p>

              <div className="mt-6 grid grid-cols-2 gap-2 sm:grid-cols-4 sm:gap-3">

                <HeroTier
                  value="100%"
                />

                <HeroTier
                  value="150%"
                />

                <HeroTier
                  value="200%"
                />

                <HeroTier
                  value="300%"
                  featured
                />

              </div>

              <div className="mt-6 text-[10px] font-black uppercase tracking-[0.18em] text-white sm:text-xs">
                HOW HIGH WILL YOU UNLOCK?
              </div>

            </div>

            {/* BUTTONS */}

            <div className="mx-auto mt-8 grid max-w-[850px] gap-3 sm:grid-cols-3">

              <a
                href={PANCAKESWAP_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex min-h-[54px] items-center justify-center rounded-[10px] border border-[#ffcc66] bg-[#ffcc66] px-7 text-[10px] font-black uppercase tracking-[0.15em] text-black shadow-[0_8px_30px_rgba(255,204,102,0.10)] transition-all duration-300 hover:-translate-y-[1px] hover:brightness-110"
              >
                Join The Rush
              </a>

              <Link
                to="/dashboard"
                className="inline-flex min-h-[54px] items-center justify-center rounded-[10px] border border-white/[0.10] bg-white/[0.03] px-7 text-[10px] font-black uppercase tracking-[0.15em] text-white transition-all duration-300 hover:-translate-y-[1px] hover:border-[#ffcc66]/30 hover:bg-[#ffcc66]/[0.04] hover:text-[#ffcc66]"
              >
                View My Bonus
              </Link>

              <a
                href={DEXSCREENER_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex min-h-[54px] items-center justify-center rounded-[10px] border border-white/[0.10] bg-white/[0.03] px-7 text-[10px] font-black uppercase tracking-[0.15em] text-white transition-all duration-300 hover:-translate-y-[1px] hover:border-[#ffcc66]/30 hover:bg-[#ffcc66]/[0.04] hover:text-[#ffcc66]"
              >
                View Chart ↗
              </a>

            </div>

          </div>

        </div>

      </section>

      {/* =====================================================
          HOW IT WORKS
      ===================================================== */}

      <section className="relative border-b border-white/[0.07] py-20 sm:py-24">

        <div className="mx-auto max-w-[1250px] px-5 sm:px-8 lg:px-10">

          <SectionHeader
            eyebrow="KIND BONUS RUSH"
            title="How It Works"
            description="Five simple steps from your first purchase to your final reward claim."
          />

          <div className="mt-12 grid auto-rows-fr gap-4 sm:grid-cols-2 lg:grid-cols-5">

            <StepCard
              number="01"
              title="Start Fresh"
            >
              Connect a new-to-$KIND wallet that has never
              previously interacted with Kind Cat Token.
            </StepCard>

            <StepCard
              number="02"
              title="Buy $KIND"
            >
              Make your qualifying $KIND purchase during the
              active Bonus Rush. Multiple qualifying purchases
              during the qualification period can count up to
              the campaign maximum.
            </StepCard>

            <StepCard
              number="03"
              title="Hold"
            >
              Your first qualifying purchase starts your
              qualification period. Keep your $KIND in your
              wallet and stay qualified.
            </StepCard>

            <StepCard
              number="04"
              title="Unlock 🔥"
              featured
            >
              Complete the qualification period and discover
              the bonus tier your qualifying purchase has
              unlocked.
            </StepCard>

            <StepCard
              number="05"
              title="Claim"
            >
              Your unlocked bonus is divided into 4 claims and
              paid in $KIND. Complete your claims before the
              claim period ends or the campaign is officially
              closed.
            </StepCard>

          </div>

        </div>

      </section>

      {/* =====================================================
          BONUS TIERS
      ===================================================== */}

      <section className="border-b border-white/[0.07] py-20 sm:py-24">

        <div className="mx-auto max-w-[1250px] px-5 sm:px-8 lg:px-10">

          <SectionHeader
            eyebrow="UNLOCK YOUR LEVEL"
            title="Bonus Tiers"
            description="The more qualifying $KIND you purchase, the higher your potential campaign bonus tier."
          />

          <div className="mt-12 grid auto-rows-fr grid-cols-2 gap-4 lg:grid-cols-4">

            <BonusCard
              value="100%"
              label="Bonus Tier"
            />

            <BonusCard
              value="150%"
              label="Bonus Tier"
            />

            <BonusCard
              value="200%"
              label="Bonus Tier"
            />

            <BonusCard
              value="300%"
              label="Maximum Bonus"
              featured
            />

          </div>

        </div>

      </section>

      {/* =====================================================
          BUILT FOR HOLDERS
      ===================================================== */}

      <section className="relative border-b border-white/[0.07] py-20 sm:py-24">

        <div className="pointer-events-none absolute left-1/2 top-1/2 h-[400px] w-[700px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-[#ffcc66]/[0.03] blur-[130px]" />

        <div className="relative mx-auto max-w-[1000px] px-5 text-center sm:px-8">

          <div className="text-[9px] font-black uppercase tracking-[0.22em] text-[#ffcc66]">
            HOLD STRONG
          </div>

          <h2 className="mt-4 text-3xl font-black uppercase tracking-[-0.03em] sm:text-4xl lg:text-5xl">
            BUILT FOR HOLDERS 💎
          </h2>

          <p className="mx-auto mt-6 max-w-[760px] text-sm leading-7 text-[#919191] sm:text-base sm:leading-8">
            KIND Bonus Rush rewards participation and holding.
          </p>

          <p className="mx-auto mt-2 max-w-[760px] text-sm leading-7 text-[#919191] sm:text-base sm:leading-8">
            Once you enter the Rush, keep your $KIND in your
            participating wallet until you've completed your
            claims.
          </p>

          <div className="mx-auto mt-8 max-w-[780px] rounded-[14px] border border-red-500/20 bg-red-500/[0.035] p-5 sm:p-6">

            <div className="text-[11px] font-black uppercase leading-6 tracking-[0.09em] text-red-300 sm:text-sm">
              Selling or transferring $KIND before completion
              will cancel your remaining bonus.
            </div>

          </div>

        </div>

      </section>

      {/* =====================================================
          CLAIM STRUCTURE
      ===================================================== */}

      <section className="border-b border-white/[0.07] py-20 sm:py-24">

        <div className="mx-auto max-w-[1250px] px-5 sm:px-8 lg:px-10">

          <SectionHeader
            eyebrow="IMPORTANT INFORMATION"
            title="Claim Structure"
            description="Understand how your potential bonus is distributed during the active Bonus Rush."
          />

          <div className="mt-12 grid auto-rows-fr gap-4 sm:grid-cols-2 lg:grid-cols-3">

            <InfoCard
              number="01"
              title="4 Total Claims"
            >
              Your total potential bonus is divided into four
              separate claims.
            </InfoCard>

            <InfoCard
              number="02"
              title="24 Hour Cooldown"
            >
              A wallet can complete a maximum of one successful
              claim every 24 hours.
            </InfoCard>

            <InfoCard
              number="03"
              title="Reward Pool"
            >
              Claims are paid from the available KIND Bonus
              Rush reward pool.
            </InfoCard>

            <InfoCard
              number="04"
              title="Pending Claims"
            >
              If sufficient reward funds are unavailable, your
              eligible claim may be attempted again while claims
              remain open.
            </InfoCard>

            <InfoCard
              number="05"
              title="Campaign Expiry"
            >
              When the claim period ends or the campaign is
              officially closed, remaining unclaimed bonus
              entitlements expire.
            </InfoCard>

            <InfoCard
              number="06"
              title="Claimed Rewards"
            >
              Rewards already successfully claimed and paid
              to your wallet remain yours.
            </InfoCard>

          </div>

          <div className="mt-8 text-center">

            <Link
              to="/rules"
              className="inline-flex min-h-[50px] items-center justify-center rounded-[10px] border border-[#ffcc66]/25 bg-[#ffcc66]/[0.045] px-8 text-[10px] font-black uppercase tracking-[0.16em] text-[#ffcc66] transition-all duration-300 hover:border-[#ffcc66]/40 hover:bg-[#ffcc66]/[0.08]"
            >
              Read Full Rules
            </Link>

          </div>

        </div>

      </section>

      {/* =====================================================
          READY
      ===================================================== */}

      <section className="relative overflow-hidden border-b border-white/[0.07] py-24 sm:py-28">

        <div className="pointer-events-none absolute left-1/2 top-1/2 h-[500px] w-[850px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-[#ffcc66]/[0.055] blur-[150px]" />

        <div className="relative mx-auto max-w-[900px] px-5 text-center sm:px-8">

          <div className="text-[9px] font-black uppercase tracking-[0.22em] text-[#ffcc66]">
            ENTER THE CAMPAIGN
          </div>

          <h2 className="mt-4 text-4xl font-black uppercase tracking-[-0.04em] sm:text-5xl lg:text-6xl">
            READY FOR THE RUSH?
          </h2>

          <p className="mx-auto mt-6 max-w-[600px] text-sm leading-7 text-[#999] sm:text-base">
            New to $KIND? Get your wallet ready.
            Get your BNB ready.
          </p>

          <div className="mt-8">
            <AnimatedRushWords />
          </div>

          <div className="mx-auto mt-9 grid max-w-[650px] gap-3 sm:grid-cols-2">

            <a
              href={PANCAKESWAP_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex min-h-[56px] items-center justify-center rounded-[10px] bg-[#ffcc66] px-8 text-[10px] font-black uppercase tracking-[0.16em] text-black transition-all duration-300 hover:-translate-y-[1px] hover:brightness-110"
            >
              Join Kind Bonus Rush
            </a>

            <a
              href={DEXSCREENER_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex min-h-[56px] items-center justify-center rounded-[10px] border border-white/[0.10] bg-white/[0.025] px-8 text-[10px] font-black uppercase tracking-[0.16em] text-white transition-all duration-300 hover:-translate-y-[1px] hover:border-[#ffcc66]/30 hover:text-[#ffcc66]"
            >
              View KIND Chart ↗
            </a>

          </div>

        </div>

      </section>

      {/* =====================================================
          TOKEN
      ===================================================== */}

      <section className="py-20 sm:py-24">

        <div className="mx-auto max-w-[1000px] px-5 text-center sm:px-8">

          <div className="text-[9px] font-black uppercase tracking-[0.22em] text-[#666]">
            POWERED BY KIND CAT TOKEN
          </div>

          <h2 className="mt-4 text-2xl font-black uppercase sm:text-3xl">
            $KIND | Kind Cat Token
          </h2>

          <p className="mt-3 text-sm font-semibold text-[#ffcc66]">
            The Trillion-Dollar Meme That Hugs Back
          </p>

          {/* BSCSCAN CONTRACT */}

          <a
            href={BSCSCAN_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="group mx-auto mt-8 block max-w-[720px] rounded-[14px] border border-white/[0.08] bg-[#08090b] p-5 transition-all duration-300 hover:border-[#ffcc66]/30 hover:bg-[#ffcc66]/[0.025] sm:p-6"
          >

            <div className="text-[8px] font-black uppercase tracking-[0.2em] text-[#555] transition-colors group-hover:text-[#ffcc66]">
              Official Contract Address ↗
            </div>

            <div className="mt-3 break-all font-mono text-[10px] leading-6 text-[#c5c5c5] transition-colors group-hover:text-white sm:text-[13px]">
              {KIND_TOKEN}
            </div>

          </a>

          <div className="mx-auto mt-4 grid max-w-[720px] gap-3 sm:grid-cols-2">

            <a
              href={PANCAKESWAP_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex min-h-[50px] items-center justify-center rounded-[9px] bg-[#ffcc66] px-6 text-[9px] font-black uppercase tracking-[0.14em] text-black transition hover:brightness-110"
            >
              Buy $KIND
            </a>

            <a
              href={DEXSCREENER_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex min-h-[50px] items-center justify-center rounded-[9px] border border-white/[0.10] bg-white/[0.025] px-6 text-[9px] font-black uppercase tracking-[0.14em] text-white transition hover:border-[#ffcc66]/30 hover:text-[#ffcc66]"
            >
              DexScreener Chart ↗
            </a>

          </div>


{/* =====================================================
    IMPORTANT NOTE - BELOW BUTTONS
===================================================== */}

<div className="mx-auto mt-5 w-full max-w-[1220px] overflow-hidden rounded-[14px] border border-[#ffcc66]/20 bg-[#ffcc66]/[0.035] p-4 text-left sm:p-5 md:p-6">

  <div className="flex items-center gap-2">

    <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-[8px] border border-[#ffcc66]/20 bg-[#ffcc66]/[0.07] text-sm">
      ⚠️
    </div>

    <div className="text-[9px] font-black uppercase tracking-[0.18em] text-[#ffcc66] sm:text-[10px]">
      Important Note
    </div>

  </div>

  <div className="mt-4 space-y-3 text-[11px] leading-6 text-[#929292] sm:text-[12px] sm:leading-7 md:text-[13px]">

    <p>
      Your dashboard shows your potential{" "}
      <strong className="text-white">
        $KIND bonus
      </strong>{" "}
      during the Bonus Rush.
    </p>

    <p>
      Bonuses are divided into{" "}
      <strong className="text-[#ffcc66]">
        4 claim portions
      </strong>
      , with one successful claim allowed every{" "}
      <strong className="text-[#ffcc66]">
        24 hours
      </strong>
      .
    </p>

    <p>
      Each bonus portion becomes earned only after a{" "}
      <strong className="text-white">
        successful claim and payout
      </strong>
      .
    </p>

    <p>
      All claims are subject to the{" "}
      <strong className="text-white">
        allocated reward pool, wallet eligibility and the
        Bonus Rush campaign period
      </strong>
      .
    </p>

    <p>
      Any unclaimed bonus expires when the{" "}
      <strong className="text-red-300">
        Bonus Rush ends
      </strong>
      .
    </p>

  </div>

  <div className="mt-4 w-full rounded-[10px] border border-[#ffcc66]/20 bg-[#050609]/60 px-3 py-3 text-center text-[10px] font-bold leading-5 text-[#ffcc66] sm:px-4 sm:text-[11px] md:text-[12px]">
    Keep holding, stay eligible and complete your claims
    while the Rush is active. 🐱❤️
  </div>

</div>
        </div>



      </section>




    </div>
    
  );
}

/* =========================================================
   ANIMATED BUY / HOLD / UNLOCK / CLAIM
========================================================= */

function AnimatedRushWords() {
  const words = [
    "BUY",
    "HOLD",
    "UNLOCK",
    "CLAIM",
  ];

  const [
    activeIndex,
    setActiveIndex,
  ] = useState(0);

  useEffect(() => {
    const timer =
      setInterval(
        () => {
          setActiveIndex(
            (current) =>
              (current + 1) %
              words.length
          );
        },
        1400
      );

    return () =>
      clearInterval(timer);
  }, []);

  return (
    <div className="mt-7 flex items-center justify-center gap-x-3 whitespace-nowrap sm:gap-x-7">

      {words.map(
        (
          word,
          index
        ) => {
          const active =
            activeIndex === index;

          return (
            <span
              key={word}
              className={`relative inline-block pb-[5px] text-[11px] font-black uppercase tracking-[0.08em] transition-colors duration-500 sm:text-xl sm:tracking-[0.12em] md:text-2xl ${
                active
                  ? "text-[#ffcc66]"
                  : "text-[#666]"
              }`}
            >
              {word}

              <span
                className={`absolute bottom-0 left-0 h-[2px] bg-[#ffcc66] transition-all duration-500 ${
                  active
                    ? "w-full opacity-100"
                    : "w-0 opacity-0"
                }`}
              />

            </span>
          );
        }
      )}

    </div>
  );
}

/* =========================================================
   HERO TIER
========================================================= */

function HeroTier({
  value,
  featured = false,
}) {
  return (
    <div
      className={`flex min-h-[62px] items-center justify-center rounded-[10px] border px-2 text-sm font-black sm:min-h-[70px] sm:text-lg ${
        featured
          ? "border-[#ffcc66]/40 bg-[#ffcc66]/10 text-[#ffcc66] shadow-[0_0_25px_rgba(255,204,102,0.06)]"
          : "border-white/[0.08] bg-black/30 text-white"
      }`}
    >
      {value}
    </div>
  );
}

/* =========================================================
   SECTION HEADER
========================================================= */

function SectionHeader({
  eyebrow,
  title,
  description,
}) {
  return (
    <div className="mx-auto max-w-[760px] text-center">

      <div className="text-[9px] font-black uppercase tracking-[0.22em] text-[#ffcc66]">
        {eyebrow}
      </div>

      <h2 className="mt-3 text-3xl font-black uppercase tracking-[-0.035em] sm:text-4xl lg:text-5xl">
        {title}
      </h2>

      {description && (
        <p className="mx-auto mt-5 max-w-[650px] text-sm leading-7 text-[#858585] sm:text-[15px]">
          {description}
        </p>
      )}

    </div>
  );
}

/* =========================================================
   STEP CARD
========================================================= */

function StepCard({
  number,
  title,
  children,
  featured = false,
}) {
  return (
    <div
      className={`flex h-full min-h-[260px] flex-col rounded-[16px] border p-6 transition-all duration-300 ${
        featured
          ? "border-[#ffcc66]/25 bg-[#ffcc66]/[0.045]"
          : "border-white/[0.08] bg-white/[0.02] hover:border-[#ffcc66]/20 hover:bg-[#ffcc66]/[0.02]"
      }`}
    >

      <div
        className={`flex h-9 w-9 items-center justify-center rounded-[8px] border text-[9px] font-black ${
          featured
            ? "border-[#ffcc66]/30 bg-[#ffcc66]/10 text-[#ffcc66]"
            : "border-white/[0.08] bg-black/30 text-[#ffcc66]"
        }`}
      >
        {number}
      </div>

      <h3 className="mt-6 text-lg font-black uppercase leading-6">
        {title}
      </h3>

      <p className="mt-4 flex-1 text-[13px] leading-7 text-[#888]">
        {children}
      </p>

      <div
        className={`mt-6 h-[2px] w-10 ${
          featured
            ? "bg-[#ffcc66]"
            : "bg-white/[0.08]"
        }`}
      />

    </div>
  );
}

/* =========================================================
   BONUS CARD
========================================================= */

function BonusCard({
  value,
  label,
  featured = false,
}) {
  return (
    <div
      className={`flex h-full min-h-[170px] flex-col items-center justify-center rounded-[16px] border p-5 text-center transition-all duration-300 ${
        featured
          ? "border-[#ffcc66]/35 bg-[#ffcc66]/[0.06]"
          : "border-white/[0.08] bg-white/[0.02] hover:border-[#ffcc66]/20"
      }`}
    >

      <div
        className={`text-3xl font-black sm:text-4xl ${
          featured
            ? "text-[#ffcc66]"
            : "text-white"
        }`}
      >
        {value}
      </div>

      <div className="mt-3 text-[9px] font-black uppercase tracking-[0.16em] text-[#666]">
        {label}
      </div>

    </div>
  );
}

/* =========================================================
   INFO CARD
========================================================= */

function InfoCard({
  number,
  title,
  children,
}) {
  return (
    <div className="flex h-full min-h-[210px] flex-col rounded-[15px] border border-white/[0.08] bg-white/[0.02] p-6 transition-all duration-300 hover:border-[#ffcc66]/20">

      <div className="text-[9px] font-black tracking-[0.18em] text-[#ffcc66]">
        {number}
      </div>

      <h3 className="mt-4 text-base font-black uppercase">
        {title}
      </h3>

      <p className="mt-4 flex-1 text-[13px] leading-7 text-[#888]">
        {children}
      </p>

    </div>
  );
}